<template>
  <div class="align-items-center">
    <span
      class="badge"
      :class="{
        'light text-dark': modelValue === 0 || modelValue == null,
        'info text-dark': modelValue === 1,
        'primary text-white': modelValue === 2,
      }"
    >
      {{ getValue(modelValue) }}
    </span>
  </div>
</template>
<script>
export default {
  name: "Priority",
  props: {
    id: Number,
    row: Object,
    modelValue: Boolean,
    extraRow: String,
  },
  methods: {
    getValue(a) {
      if (a === 0) {
        return "Low";
      }
      if (a === 1) {
        return "Normal";
      }
      if (a === 2) {
        return "High";
      }
      return "-";
    },
  },
};
</script>
